import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Row, Col } from '@zendeskgarden/react-grid';
import { API_URL, KONG_CLIENT_ID } from 'config/constants';
import Image from 'components/Image';
import t from 'components/i18n';
import Container from 'components/Container';
import { Item } from './Orientation.styled';

export default function OpenOrientationCard({ data, back }) {
  const user = useSelector(state => state.user);
  return (
    <Container hideDetail className="animated">
      {/* <Item className="flex">
        <span className="label">Motivo da visita</span>{' '}
        <span>{data.orientation}</span>
      </Item> */}

      <Item className="flex">
        <span className="label">{t('rientations.card.date-hour')}</span>{' '}
        <div
          className="flex"
          style={{ flexDirection: 'column', textAlign: 'right' }}
        >
          <span className="margin">
            {moment(data.visitDate).format('DD ̸̸  MM ̸̸  YYYY')}
          </span>
          <span className="small">
            {moment(data.visitDate).format('HH:mm')}
          </span>
        </div>
      </Item>

      <Item>
        <span className="label">{t('orientations.card.title')}</span>{' '}
        <p>{data.orientation}</p>
      </Item>

      {data.blobNameList && data.blobNameList.length > 0 && (
        <Item>
          <span className="label">{t('orientations.card.pictures')}</span>
          <br />
          <br />
          <Row>
            {data.blobNameList.map((item, index) => (
              <Col key={index} sm={4}>
                <a
                  href={`${API_URL}/Blob/Download?fileName=${item}&blobContainerName=logbookattachment&token=${user.token}&client_id=${KONG_CLIENT_ID}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    api={API_URL}
                    fileName={item}
                    blobContainer="logbookattachment"
                    token={user.token}
                  />
                </a>
              </Col>
            ))}
          </Row>
        </Item>
      )}
    </Container>
  );
}
